import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '../App'
import { AppAuth0Provider } from '../auth0-provider'
import '../index.css'

const element = document.getElementById('root')
if (element) {
  createRoot(element).render(
    <StrictMode>
      <AppAuth0Provider>
        <App />
      </AppAuth0Provider>
    </StrictMode>
  )
}
